import { createSelector } from "reselect";
export const getNotificationReducer = state => state.notification;

export const getNotificationSelector = createSelector(
	[getNotificationReducer],
	({ lastNotification }) => ({
		lastNotification
	})
);
